<template>
  <div class="step" :class="[!$route.meta.sidebar ? 'no-canvas' : '']">
    <v-item-headline/>
    <v-item-refine/>
    <v-item-list/>
  </div>
</template>



<script>
export default {
  components: {
    'v-item-headline': require('@/components/item-headline.vue').default,
    'v-item-refine': require('@/components/item-refine.vue').default,
    'v-item-list': require('@/components/item-list.vue').default,
  },
}
</script>



<style lang="scss">
.step {
  padding-top: 160px;
  padding-bottom: 96px;
  @include breakpoints-min(md) {
    padding-top: 272px;
  }
  @include breakpoints-min(lg) {
    padding-top: 0;
    padding-bottom: 112px;
  }
  &.no-canvas {
    padding-top: 0;
  }
}
</style>
